export enum QuizSubject {
  MATH = 'math',
  SCIENCE = 'science',
  ARABIC = 'arabic',
  ENGLISH = 'english',
  ISLAMIC = 'islamic',
  SOCIAL = 'social',
  GENERAL = 'general'
}

export enum DifficultyLevel {
  EASY = 'easy',
  MEDIUM = 'medium',
  HARD = 'hard'
}

export interface BilingualText {
  en: string;
  ar: string;
}

export interface QuestionOption {
  id: 'A' | 'B' | 'C' | 'D';
  text: BilingualText;
}

export interface GameQuestion {
  id: string;
  subject: QuizSubject;
  difficulty: DifficultyLevel;
  gradeRange: { min: number; max: number };
  text: BilingualText;
  options: QuestionOption[];
  correctOptionId: 'A' | 'B' | 'C' | 'D';
  timeLimit: number; // seconds
  xpReward: number; // base XP before multipliers
  imageUrl?: string;
  explanation?: BilingualText;
}

export interface QuizSession {
  questions: GameQuestion[];
  currentIndex: number;
  answers: QuizAnswer[];
  subject: QuizSubject | 'random';
  startedAt: Date;
}

export interface QuizAnswer {
  questionId: string;
  selectedOptionId: 'A' | 'B' | 'C' | 'D' | null;
  isCorrect: boolean;
  timeRemaining: number;
  xpEarned: number;
}
